<script setup lang="ts">
  import { ref } from 'vue'

  withDefaults(defineProps<{ delay?: number }>(), { delay: 0 })

  const done = ref(false)
</script>

<template>
  <div
    :class="{ 'des-enter': !done }"
    :style="delay && !done ? { animationDelay: `${delay}ms` } : undefined"
    @animationend.self="done = true"
  >
    <slot />
  </div>
</template>

<style scoped>
  .des-enter {
    animation: des-enter 1s cubic-bezier(0.16, 1, 0.3, 1) both;
  }

  @keyframes des-enter {
    from {
      opacity: 0;
      transform: translateY(1.25rem);
    }
  }
</style>
